// DochadzkaMobile — obrazovka DNES (mview_appka_v1, 17. 10. 2026). Kopíruje schválený iOS mockup appky pre zamestnancov
// (Kronika 1508/1513/1516): zákazka ťuknutím (z Rozpisu prác, „Iná…“ = všetky), veľký PRÍCHOD, po príchode zákazka, čas,
// počasie podľa adresy zákazky, „Dnes s tebou“, odpracované, Otvoriť denník dňa, Zmena stavby, ODCHOD, po odchode súhrn.
// Backend (ústava 121): POST /api/dochadzka (úsek, client_uid = idempotencia) · PATCH /api/dochadzka/:id/koniec ·
// GET /api/dochadzka/dnes/:emp · GET /api/dochadzka/projekty?moje=1 · GET /api/weather?project_id= · GET /api/dochadzka/?project_id=&od=&do=.
// Starý most pichačky (bez client_uid a bez offline) sa tu už nepoužíva. Offline: offline/dochadzkaOffline.js.
// Príchod je PRVÝ krok dňa — denník a pokládka sa odomknú až po ňom (Mirko 1426), zámok drží server (423) aj MobileApp.
import React, { useEffect, useState, useCallback, useRef } from 'react'
import { M } from '../views/mockupTheme.js'   // mview_appka_v2: vzhľad = mockup v5 (Mirko 18. 10., Kronika 1585)
import { fetchAuth } from '../auth/fetchAuth.js'
import { useToast } from './Toast.jsx'
import { useT } from '../i18n.js'
import { doAll, doPut, noveUid, flushDochadzka, dkvGet, dkvSet } from '../offline/dochadzkaOffline.js'

const dnesISO = () => { const d = new Date(); return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10) }
const teraz = () => { const d = new Date(); return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0') }
const min = (t) => { const m = String(t || '').match(/(\d{1,2}):(\d{2})/); return m ? Number(m[1]) * 60 + Number(m[2]) : null }
const hod = (n) => (Math.round(n * 100) / 100).toFixed(2).replace('.', ',')

function ziskajGps() {
  // Pichačka NIKDY nezlyhá kvôli GPS (ústava 121.4): zamietnuté povolenie alebo pivnica = pošle sa bez polohy.
  return new Promise(resolve => {
    if (!navigator.geolocation) return resolve(null)
    const t = setTimeout(() => resolve(null), 6000)
    navigator.geolocation.getCurrentPosition(
      pos => { clearTimeout(t); resolve({ lat: pos.coords.latitude, lng: pos.coords.longitude }) },
      () => { clearTimeout(t); resolve(null) },
      { enableHighAccuracy: true, timeout: 5500, maximumAge: 60000 })
  })
}

export default function DochadzkaMobile({ me, onZmena, onOtvorDennik }) {
  const t = useT()
  const toast = useToast()
  const [emp, setEmp] = useState((me && me.employee_id) || '')
  const [moje, setMoje] = useState([])
  const [vsetky, setVsetky] = useState(null)      // null = ešte nenačítané („Iná…“)
  const [sel, setSel] = useState('')
  const [den, setDen] = useState(null)            // { otvoreny, rows, spolu }
  const [pocasie, setPocasie] = useState(null)
  const [ludia, setLudia] = useState([])
  const [busy, setBusy] = useState(false)
  const [fronta, setFronta] = useState(0)
  const [zmena, setZmena] = useState(false)
  const [znova, setZnova] = useState(false)
  const [tik, setTik] = useState(0)
  const alive = useRef(true)
  useEffect(() => () => { alive.current = false }, [])
  useEffect(() => { const i = setInterval(() => setTik(x => x + 1), 30000); return () => clearInterval(i) }, [])

  const nacitajFrontu = useCallback(async () => { const a = await doAll(); if (alive.current) setFronta(a.length) }, [])

  const nacitajDen = useCallback(async (e) => {
    const id = e || emp; if (!id) return
    try {
      const r = await fetchAuth('/api/dochadzka/dnes/' + encodeURIComponent(id))
      if (!r.ok) throw new Error(String(r.status))
      const d = await r.json(); if (!alive.current) return
      setDen(d); dkvSet('den', d)
    } catch (_) { const c = await dkvGet('den'); if (alive.current && c && c.date === dnesISO()) setDen(c); else if (alive.current) setDen(d => d || { date: dnesISO(), rows: [], otvoreny: null, spolu: 0 }) }
  }, [emp])

  // kto som (employee_id) → zákazky z Rozpisu → stav dňa
  useEffect(() => {
    let e = emp
    ;(async () => {
      if (!e) { try { const m = await fetchAuth('/api/mobile/modules').then(r => r.ok ? r.json() : null); e = (m && m.employee_id) || ''; if (alive.current) setEmp(e) } catch (_) {} }
      try {
        const r = await fetchAuth('/api/dochadzka/projekty?moje=1'); const a = r.ok ? await r.json() : []
        if (alive.current) { setMoje(Array.isArray(a) ? a : []); dkvSet('moje', a) }
      } catch (_) { const c = await dkvGet('moje'); if (alive.current && Array.isArray(c)) setMoje(c) }
      await nacitajDen(e); await nacitajFrontu()
      const f = await flushDochadzka(); if (f.sent) { await nacitajDen(e); await nacitajFrontu(); if (onZmena) onZmena() }
    })()
    const on = async () => { const f = await flushDochadzka(); if (f.sent) { await nacitajDen(); await nacitajFrontu(); if (onZmena) onZmena() } }
    window.addEventListener('online', on)
    return () => window.removeEventListener('online', on)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const rows = (den && den.rows) || []
  const otvoreny = den && den.otvoreny
  const posledny = rows.length ? rows[rows.length - 1] : null
  const zakazkaDna = (otvoreny && otvoreny.project_id) || (posledny && posledny.project_id) || ''
  const nazovDna = (otvoreny && otvoreny.project_name) || (posledny && posledny.project_name) || zakazkaDna
  useEffect(() => { if (!sel) { if (zakazkaDna) setSel(zakazkaDna); else if (moje.length) setSel(moje[0].id) } }, [moje, zakazkaDna]) // eslint-disable-line react-hooks/exhaustive-deps

  // počasie podľa adresy zákazky (server: Nominatim + Open-Meteo, ústava 25.6) a „Dnes s tebou“ (kto dnes pichol na zákazke)
  useEffect(() => {
    if (!zakazkaDna || !otvoreny) { setPocasie(null); setLudia([]); return }
    let ok = true
    fetchAuth('/api/weather?project_id=' + encodeURIComponent(zakazkaDna) + '&date=' + dnesISO()).then(r => r.ok ? r.json() : null).then(w => { if (ok) setPocasie(w) }).catch(() => { if (ok) setPocasie(null) })
    fetchAuth('/api/dochadzka/?project_id=' + encodeURIComponent(zakazkaDna) + '&od=' + dnesISO() + '&do=' + dnesISO()).then(r => r.ok ? r.json() : []).then(a => {
      if (!ok) return
      const m = new Map(); (Array.isArray(a) ? a : []).forEach(x => { if (x.start_at) m.set(x.employee_id, x.employee_name || x.employee_id) })
      setLudia([...m.values()])
    }).catch(() => { if (ok) setLudia([]) })
    return () => { ok = false }
  }, [zakazkaDna, !!otvoreny, rows.length])

  // odpracované dnes = uzavreté úseky + bežiaci úsek
  const odpracovane = (() => {
    let s = 0
    rows.forEach(r => { if (r.end_at) s += Number(r.hodiny_platne != null ? r.hodiny_platne : r.hodiny) || 0; else { const a = min(r.start_at), b = min(teraz()); if (a != null && b != null && b >= a) s += (b - a) / 60 } })
    return s
  })()

  async function prichod(pid) {
    const projektId = pid || sel
    if (!emp) { toast.error(t('mobile.dnes.bez_zamestnanca')); return }
    if (!projektId) { toast.error(t('mobile.dnes.vyber_zakazku')); return }
    setBusy(true)
    const gps = await ziskajGps()
    const body = { employee_id: emp, project_id: projektId, date: dnesISO(), start_at: teraz(), start_lat: gps ? String(gps.lat) : '', start_lng: gps ? String(gps.lng) : '' }
    const uid = noveUid()
    try {
      const r = await fetchAuth('/api/dochadzka/', { method: 'POST', body: JSON.stringify({ ...body, client_uid: uid }) })
      const d = await r.json().catch(() => ({}))
      if (!r.ok) throw Object.assign(new Error(d.error || ('Chyba ' + r.status)), { trvala: r.status >= 400 && r.status < 500 })
      await dkvSet('id:' + uid, d.id)
      toast.success(t('mobile.dnes.prichod_ok', { cas: body.start_at }) + (gps ? '' : ' · ' + t('mobile.dnes.bez_gps')))
    } catch (e) {
      if (e.trvala) { toast.error(e.message); setBusy(false); return }
      // bez siete: do fronty, pošle sa pri prvej príležitosti (121.3); obrazovka ukáže príchod hneď
      await doPut({ client_uid: uid, typ: 'prichod', body, employee_id: emp, cas: new Date().toISOString() })
      setDen(d => ({ ...(d || { date: dnesISO(), spolu: 0 }), rows: [...((d && d.rows) || []), { id: 'LOCAL-' + uid, client_uid: uid, ...body, project_name: (moje.find(p => p.id === projektId) || {}).name || projektId, end_at: '' }], otvoreny: { id: 'LOCAL-' + uid, client_uid: uid, ...body, project_name: (moje.find(p => p.id === projektId) || {}).name || projektId } }))
      toast.warn(t('mobile.dnes.offline_ulozene'))
    }
    setZnova(false); setZmena(false); setBusy(false)
    await nacitajDen(); await nacitajFrontu(); if (onZmena) onZmena()
  }

  async function odchod(tichy) {
    if (!otvoreny) return
    setBusy(true)
    const gps = await ziskajGps()
    const body = { end_at: teraz(), end_lat: gps ? String(gps.lat) : '', end_lng: gps ? String(gps.lng) : '' }
    const lokalny = String(otvoreny.id || '').startsWith('LOCAL-')
    try {
      if (lokalny) throw Object.assign(new Error('lokalny'), { offline: true })
      const r = await fetchAuth('/api/dochadzka/' + encodeURIComponent(otvoreny.id) + '/koniec', { method: 'PATCH', body: JSON.stringify(body) })
      const d = await r.json().catch(() => ({}))
      if (!r.ok) throw Object.assign(new Error(d.error || ('Chyba ' + r.status)), { trvala: r.status >= 400 && r.status < 500 })
      if (!tichy) toast.success(t('mobile.dnes.odchod_ok', { cas: body.end_at }))
    } catch (e) {
      if (e.trvala) { toast.error(e.message); setBusy(false); return }
      await doPut({ client_uid: noveUid(), typ: 'odchod', body, att_id: lokalny ? '' : otvoreny.id, za_uid: otvoreny.client_uid || '', employee_id: emp, cas: new Date().toISOString() })
      setDen(d => ({ ...d, otvoreny: null, rows: (d.rows || []).map(r => r.id === otvoreny.id ? { ...r, end_at: body.end_at } : r) }))
      if (!tichy) toast.warn(t('mobile.dnes.offline_ulozene'))
    }
    setBusy(false)
    await nacitajDen(); await nacitajFrontu(); if (onZmena) onZmena()
  }

  async function zmenaStavby(pid) {
    // Zmena stavby = uzavrie úsek a začne nový na inej zákazke (ústava 121.2: úseky, nie dni)
    await odchod(true); await prichod(pid)
  }

  async function nacitajVsetky() {
    try { const r = await fetchAuth('/api/dochadzka/projekty'); const a = r.ok ? await r.json() : []; setVsetky(Array.isArray(a) ? a.filter(p => p.status !== 'done') : []) } catch (_) { setVsetky([]) }
  }

  // ── štýly (mockup: veľké plochy, ústava 60) ──
  const karta = { background: M.card, border: `1px solid ${M.line}`, borderRadius: 16, padding: 16, marginBottom: 16 }
  const nadpis = { margin: '0 0 10px', fontSize: 13, fontWeight: 700, color: M.mut, textTransform: 'uppercase', letterSpacing: '0.04em' }
  const velke = (bg, dis) => ({ width: '100%', minHeight: 72, border: 'none', borderRadius: 16, background: dis ? '#a5a8ae' : bg, color: '#fff', fontSize: 20, fontWeight: 800, cursor: dis ? 'default' : 'pointer', fontFamily: 'inherit', letterSpacing: '0.02em' })
  const tiche = { width: '100%', minHeight: 52, border: `1px solid ${M.line}`, borderRadius: 16, background: M.field, color: M.txt, fontSize: 16, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }
  const chip = (on) => ({ display: 'inline-flex', alignItems: 'center', minHeight: 48, padding: '10px 16px', margin: '0 8px 8px 0', borderRadius: 999, border: `1px solid ${on ? M.ac : M.line}`, background: on ? M.ac : M.card, color: on ? '#fff' : M.txt, fontSize: 16, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' })
  const hint = { fontSize: 14, color: M.mut, textAlign: 'center', margin: '10px 0' }
  const riadok = { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0', borderBottom: `1px solid ${M.field}`, fontSize: 16 }

  const zoznam = (vsetky || moje)
  const meno = (me && (me.display_name || me.username)) || ''
  const hotovoZaDnes = !otvoreny && rows.length > 0 && !znova

  return (
    <div style={{ padding: 16, paddingBottom: 24, background: M.bg, minHeight: '100%', fontFamily: M.font, color: M.txt }}>
      <div style={{ fontSize: 26, fontWeight: 800, margin: '4px 0 2px', letterSpacing: '-0.01em' }}>{t('mobile.dnes.pozdrav')}{meno ? ', ' + meno.split(' ')[0] : ''}</div>
      <div style={{ color: M.mut, fontSize: 14, marginBottom: 16 }}>{new Date().toLocaleDateString('sk-SK', { weekday: 'long', day: 'numeric', month: 'numeric', year: 'numeric' })}{fronta ? ' · ' + t('mobile.dnes.fronta', { n: fronta }) : ''}</div>

      {den === null && <div style={hint}>{t('common.loading')}</div>}

      {den !== null && !otvoreny && !hotovoZaDnes && (
        <>
          <div style={karta}>
            <div style={nadpis}>{t('mobile.dnes.kde_robis')}</div>
            <div>
              {zoznam.map(p => <button key={p.id} type="button" style={chip(sel === p.id)} onClick={() => setSel(p.id)}>{p.zakazka_code || p.id} · {p.name || ''}</button>)}
              {vsetky === null && <button type="button" style={chip(false)} onClick={nacitajVsetky}>{t('mobile.dnes.ina')}</button>}
              {!zoznam.length && vsetky !== null && <div style={{ color: M.mut }}>{t('mobile.dnes.ziadne_zakazky')}</div>}
            </div>
            <div style={{ ...hint, textAlign: 'left', margin: '4px 0 0' }}>{vsetky === null ? t('mobile.dnes.z_rozpisu') : t('mobile.dnes.vsetky')}</div>
          </div>
          <button type="button" disabled={busy || !sel} style={velke(M.grn, busy || !sel)} onClick={() => prichod()}>{busy ? t('mobile.dnes.ukladam') : t('mobile.dnes.prichod')}</button>
          <div style={hint}>{t('mobile.dnes.gps_hint')}</div>
          {rows.length > 0 && <div style={hint}>{t('mobile.dnes.dnes_uz', { h: hod(odpracovane) })}</div>}
        </>
      )}

      {otvoreny && (
        <>
          <div style={karta}>
            <div style={{ ...riadok, paddingTop: 0 }}><span style={{ color: M.mut, fontSize: 14 }}>{t('mobile.dnes.si_na_stavbe')}</span><span style={{ background: 'rgba(22,163,74,.13)', color: M.grn, borderRadius: 999, padding: '4px 10px', fontSize: 13, fontWeight: 700 }}>{t('mobile.dnes.prichod')} {otvoreny.start_at}</span></div>
            <div style={{ fontSize: 19, fontWeight: 800, margin: '8px 0 2px' }}>{nazovDna}</div>
            <div style={{ display: 'flex', gap: 14, alignItems: 'center', marginTop: 8 }}>
              <div style={{ fontSize: 34, fontWeight: 800 }}>{pocasie && pocasie.current != null ? Math.round(pocasie.current) + '°' : '—'}</div>
              <div style={{ fontSize: 14, color: M.mut }}>
                {pocasie && pocasie.temp_min != null ? t('mobile.dnes.min_max', { min: Math.round(pocasie.temp_min), max: Math.round(pocasie.temp_max) }) : (pocasie === null ? t('mobile.dnes.pocasie_nacitavam') : t('mobile.dnes.pocasie_bez_adresy'))}
                <div>{t('mobile.dnes.pocasie_hint')}</div>
              </div>
            </div>
          </div>
          <div style={karta}>
            <div style={nadpis}>{t('mobile.dnes.s_tebou')}</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
              <div style={{ background: M.field, borderRadius: 12, padding: 12 }}><b style={{ display: 'block', fontSize: 22, color: M.ac }}>{ludia.length || 1}</b><span style={{ fontSize: 13, color: M.mut }}>{t('mobile.dnes.ludia_na_stavbe')}</span></div>
              <div style={{ background: M.field, borderRadius: 12, padding: 12 }}><b style={{ display: 'block', fontSize: 22, color: M.ac }}>{hod(odpracovane)} h</b><span style={{ fontSize: 13, color: M.mut }}>{t('mobile.dnes.odpracovane')}</span></div>
            </div>
            {ludia.length > 0 && <div style={{ marginTop: 10, fontSize: 14, color: M.mut }}>{ludia.join(' · ')}</div>}
          </div>
          {onOtvorDennik && <><button type="button" style={tiche} onClick={onOtvorDennik}>{t('mobile.dnes.otvorit_dennik')} →</button><div style={{ height: 10 }} /></>}
          {!zmena && <><button type="button" style={tiche} onClick={() => { setZmena(true); if (vsetky === null) nacitajVsetky() }}>{t('mobile.dnes.zmena_stavby')}</button><div style={{ height: 10 }} /></>}
          {zmena && (
            <div style={karta}>
              <div style={nadpis}>{t('mobile.dnes.zmena_stavby_hint')}</div>
              {(vsetky || moje).filter(p => p.id !== zakazkaDna).map(p => <button key={p.id} type="button" style={chip(false)} disabled={busy} onClick={() => zmenaStavby(p.id)}>{p.zakazka_code || p.id} · {p.name || ''}</button>)}
              <div><button type="button" style={{ ...tiche, marginTop: 6 }} onClick={() => setZmena(false)}>{t('common.cancel')}</button></div>
            </div>
          )}
          <button type="button" disabled={busy} style={velke(M.red, busy)} onClick={() => odchod(false)}>{busy ? t('mobile.dnes.ukladam') : t('mobile.dnes.odchod')}</button>
          <div style={hint}>{t('mobile.dnes.odchod_hint')}</div>
        </>
      )}

      {hotovoZaDnes && (
        <div style={{ textAlign: 'center', paddingTop: 16 }}>
          <div style={{ width: 64, height: 64, borderRadius: '50%', background: M.grn, color: '#fff', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 30, fontWeight: 800 }}>✓</div>
          <h2 style={{ margin: '8px 0 4px', fontSize: 22 }}>{t('mobile.dnes.hotovo')}</h2>
          <div style={{ color: M.mut, marginBottom: 16 }}>{rows[0].start_at} – {posledny.end_at} · <b>{hod(odpracovane)} h</b> · {nazovDna}</div>
          <div style={{ ...karta, textAlign: 'left' }}>
            <div style={nadpis}>{t('mobile.dnes.useky')}</div>
            {rows.map(r => <div key={r.id} style={riadok}><span>{r.start_at} – {r.end_at || '…'}</span><span style={{ color: M.mut, flex: 1, marginLeft: 10 }}>{r.project_name || r.project_id}</span><b>{hod(Number(r.hodiny_platne != null ? r.hodiny_platne : r.hodiny) || 0)} h</b></div>)}
          </div>
          <button type="button" style={tiche} onClick={() => { setZnova(true); setSel(zakazkaDna) }}>{t('mobile.dnes.prisiel_znova')}</button>
        </div>
      )}
    </div>
  )
}
